import { useQuery } from '@tanstack/react-query';
import { companiesService } from 'app/javascript/services/companies';

export function usePublicCompany(slug: string, options?: { retry?: boolean | number }) {
  return useQuery({
    queryKey: ['public-company', slug],
    queryFn: () => companiesService.getPublic(slug),
    ...(options?.retry === undefined ? {} : { retry: options.retry }),
  });
}

export function useCompany(slug: string) {
  return useQuery({
    queryKey: ['company', slug],
    queryFn: () => companiesService.get(slug),
  });
}

export function useCompanyMemberships(slug: string, enabled = true) {
  return useQuery({
    queryKey: ['company-memberships', slug],
    queryFn: () => companiesService.getMemberships(slug),
    enabled,
  });
}

export function useMembershipsAttendance(slug: string, enabled = true, from?: string, to?: string) {
  return useQuery({
    queryKey: ['memberships-attendance', slug, from ?? null, to ?? null],
    queryFn: () => companiesService.getMembershipsAttendance(slug, { from, to }),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
